'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Feature, Heading, LayoutContainer, Picture, TextPassage } from '@petsmart-ui/sparky';
import ReactPlayer from 'react-player';
import { useDeviceType } from '@libs/common-next';
import { trackFeatureBannerClick } from './analytics';
import type { FeatureBannerProps } from './types';
import './feature-banner.scss';
export type { FeatureBannerProps } from './types';
export function FeatureBanner(t0) {
  const $ = _c(29);
  const {
    header,
    description,
    headingTagName,
    color,
    backgroundColor,
    media,
    cta
  } = t0;
  const {
    isMobile
  } = useDeviceType();
  let t1;
  if ($[0] !== backgroundColor || $[1] !== color) {
    t1 = {
      backgroundColor,
      color
    };
    $[0] = backgroundColor;
    $[1] = color;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const style = t1;
  let t2;
  if ($[3] !== header) {
    t2 = header.trim();
    $[3] = header;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const displayHeader = t2;
  let t3;
  if ($[5] !== header || $[6] !== media.alt || $[7] !== media.autoplay || $[8] !== media.items || $[9] !== media.loop || $[10] !== media.src || $[11] !== media.type || $[12] !== media.url) {
    t3 = media.type === "image" ? <Picture items={media.items} imgSrc={media.src} imgAlt={media.alt} /> : <div className="feature-banner-video-container"><ReactPlayer data-testid="video-player" url={media.url} onPlay={() => {
        trackFeatureBannerClick("video", header);
      }} controls={true} width="100%" height="100%" playsinline={true} loop={media.loop} playing={media.autoplay} muted={media.autoplay} /></div>;
    $[5] = header;
    $[6] = media.alt;
    $[7] = media.autoplay;
    $[8] = media.items;
    $[9] = media.loop;
    $[10] = media.src;
    $[11] = media.type;
    $[12] = media.url;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  const bannerMedia = t3;
  let t4;
  if ($[14] !== displayHeader || $[15] !== headingTagName) {
    t4 = displayHeader ? <Heading tagName={headingTagName} size="title">{displayHeader}</Heading> : <span className="sparky-c-heading sparky-c-heading--title" />;
    $[14] = displayHeader;
    $[15] = headingTagName;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== description) {
    t5 = <TextPassage>{description}</TextPassage>;
    $[17] = description;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== cta || $[20] !== header || $[21] !== isMobile) {
    t6 = cta && <a data-testid="feature-banner-cta" target={cta.target} href={cta.href} onClick={() => {
      if (cta.label) {
        trackFeatureBannerClick(cta.label, header);
      }
    }} rel="noreferrer" className="feature-banner__link"><Button variant={cta.variant} text={cta.label} fullWidth={isMobile} size="lg" /></a>;
    $[19] = cta;
    $[20] = header;
    $[21] = isMobile;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] !== bannerMedia || $[24] !== style || $[25] !== t4 || $[26] !== t5 || $[27] !== t6) {
    t7 = <LayoutContainer className="feature-banner-container"><Feature className="feature-banner" media={bannerMedia} style={style}>{t4}{t5}{t6}</Feature></LayoutContainer>;
    $[23] = bannerMedia;
    $[24] = style;
    $[25] = t4;
    $[26] = t5;
    $[27] = t6;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  return t7;
}